module.exports = __webpack_public_path__ + "files/b9a1e9e45c484cae9b1437857d370c39.svg";